import { ProjectType } from 'const';
import { ReferenceCitationIndents } from '../constants';
import { Schemas } from '../models';

export function getReferenceIndent(projectType: ProjectType): Schemas.ListIndentStyles {
  return ReferenceCitationIndents[projectType];
}
